/* XO CART DRAWER SUBMIT V2 */
(() => {
  const selectors = '[data-xop-variant-id], [data-xoe-variant-id]';
  const pendingForms = new WeakSet();

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const variant = form.querySelector(selectors);
    if (!variant) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (pendingForms.has(form)) return;

    const section = form.closest('.shopify-section');
    const drawer = document.querySelector('cart-drawer');
    const button = form.querySelector('[type="submit"]');
    const errorBox = section?.querySelector('[data-xop-battery-error]');
    const battery = section?.querySelector('[data-xop-battery-checkbox]');
    const id = Number(variant.value);
    const qtyInput = form.querySelector('[name="quantity"]');
    const quantity = qtyInput ? Number(qtyInput.value) : 1;

    const showError = (message) => {
      let target = errorBox || form.querySelector('[data-xo-cart-error]');
      if (!target) {
        target = document.createElement('p');
        target.setAttribute('data-xo-cart-error', '');
        target.setAttribute('role', 'alert');
        form.appendChild(target);
      }
      target.textContent = message;
      target.hidden = false;
    };

    if (!Number.isSafeInteger(id) || id <= 0 ||
        !Number.isSafeInteger(quantity) || quantity <= 0) {
      showError('Invalid product selection.');
      return;
    }

    if (!drawer || typeof drawer.renderContents !== 'function') {
      showError('Cart drawer unavailable.');
      return;
    }

    const items = [{ id, quantity }];

    if (battery?.checked && !battery.disabled) {
      const batteryId = Number(battery.value);
      if (!Number.isSafeInteger(batteryId) || batteryId <= 0) {
        showError('Invalid battery selection.');
        return;
      }
      items.push({ id: batteryId, quantity: 1 });
    }

    pendingForms.add(form);
    if (button) button.disabled = true;
    if (errorBox) errorBox.hidden = true;

    try {
      const sections = drawer.getSectionsToRender().map(item => item.id);

      drawer.setActiveElement?.(button || document.activeElement);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname
        })
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Cart error');
      }

      // XO CART FULL PAGE REFRESH V4
      // Reload the rendered storefront HTML after Shopify updates the cart.
      const pageResponse = await fetch(window.location.href, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Accept': 'text/html' }
      });

      if (!pageResponse.ok) {
        throw new Error('Unable to load the updated cart.');
      }

      const pageHTML = await pageResponse.text();
      const documentCopy = new DOMParser().parseFromString(
        pageHTML,
        'text/html'
      );

      const incomingDrawer = documentCopy.querySelector('cart-drawer');
      const incomingInner = incomingDrawer?.querySelector('.drawer__inner');
      const currentInner = drawer.querySelector('.drawer__inner');

      if (!incomingInner || !currentInner) {
        throw new Error('Updated cart markup unavailable.');
      }

      const newItems = incomingInner.querySelectorAll(
        '#CartDrawer-CartItems .cart-item'
      );

      if (!newItems.length) {
        throw new Error('Cart items not found in updated storefront.');
      }

      currentInner.replaceWith(incomingInner);
      drawer.classList.remove('is-empty');

      const newBubble = documentCopy.querySelector('#cart-icon-bubble');
      const currentBubble = document.querySelector('#cart-icon-bubble');

      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }

      drawer.open();
    } catch (error) {
      console.error('[XO Cart]', error);
      showError(error.message || 'Unable to update cart.');
    } finally {
      pendingForms.delete(form);
      if (button) button.disabled = false;
    }
  }, true);
})();
